var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("breadcrumb-top", {
        attrs: { breadcrumbConfig: _vm.dataList, isBack: "1" },
      }),
      _c(
        "div",
        { staticClass: "content c-top" },
        [
          _c("breadcrumb-search", {
            attrs: { breadcrumbSearch: _vm.searchList },
          }),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "18px" } },
            [
              _c(
                "el-form",
                {
                  ref: "searchForm",
                  attrs: { inline: true, model: _vm.searchForm, size: "small" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品名称", prop: "name" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "232px" },
                        attrs: { placeholder: "请输入商品名称", clearable: "" },
                        model: {
                          value: _vm.searchForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "name", $$v)
                          },
                          expression: "searchForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品编号", prop: "goodsNo" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "232px" },
                        attrs: { placeholder: "请输入商品编号" },
                        model: {
                          value: _vm.searchForm.goodsNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "goodsNo", $$v)
                          },
                          expression: "searchForm.goodsNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注信息", prop: "remark" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "232px" },
                        attrs: { placeholder: "请输入备注信息" },
                        model: {
                          value: _vm.searchForm.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "remark", $$v)
                          },
                          expression: "searchForm.remark",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品类目", prop: "categoryIds" } },
                    [
                      _c("el-cascader", {
                        staticClass: "contentS",
                        staticStyle: { width: "232px" },
                        attrs: {
                          options: _vm.categoryIds,
                          "show-all-levels": false,
                          props: {
                            checkStrictly: true,
                            multiple: true,
                            emitPath: false,
                          },
                          "collapse-tags": "",
                          clearable: "",
                          filterable: "",
                          size: "small",
                        },
                        on: { change: _vm.onChangeCategory },
                        model: {
                          value: _vm.searchForm.categoryIds,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "categoryIds", $$v)
                          },
                          expression: "searchForm.categoryIds",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "上次编辑", prop: "createdTimeStart" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "232px" },
                        attrs: {
                          type: "daterange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          "default-time": ["00:00:00", "23:59:59"],
                        },
                        model: {
                          value: _vm.value1,
                          callback: function ($$v) {
                            _vm.value1 = $$v
                          },
                          expression: "value1",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "创建时间", prop: "createdTimeStart" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "232px" },
                        attrs: {
                          type: "daterange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          "default-time": ["00:00:00", "23:59:59"],
                        },
                        model: {
                          value: _vm.value2,
                          callback: function ($$v) {
                            _vm.value2 = $$v
                          },
                          expression: "value2",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "绑定SKU", prop: "sku" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "232px" },
                        attrs: { placeholder: "请输入SKU编号" },
                        model: {
                          value: _vm.searchForm.sku,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "sku", $$v)
                          },
                          expression: "searchForm.sku",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.fetchData("search")
                            },
                          },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.fetchData("reset")
                            },
                          },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "content" }, [
        _c("h3", { staticStyle: { "font-weight": "bold" } }, [
          _vm._v(" 列表数据 "),
        ]),
        _c("div", { staticClass: "btn-list" }, [
          _c(
            "div",
            { staticClass: "item" },
            [
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.selectData },
                  model: {
                    value: _vm.radio1,
                    callback: function ($$v) {
                      _vm.radio1 = $$v
                    },
                    expression: "radio1",
                  },
                },
                [
                  _c("el-radio-button", { attrs: { label: " ", border: "" } }, [
                    _vm._v(
                      "全部(" + _vm._s(_vm.countGroupByStatus.total) + ")"
                    ),
                  ]),
                  _c("el-radio-button", { attrs: { label: "1" } }, [
                    _vm._v(
                      "已上架(" +
                        _vm._s(_vm.countGroupByStatus.allShelvesCount) +
                        ")"
                    ),
                  ]),
                  _c("el-radio-button", { attrs: { label: "0" } }, [
                    _vm._v(
                      "已下架(" +
                        _vm._s(_vm.countGroupByStatus.allUnShelvesCount) +
                        ")"
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "item" }, [
            _c(
              "div",
              { staticStyle: { display: "flex" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "u-btn",
                    on: {
                      click: function ($event) {
                        return _vm.pUp("1")
                      },
                    },
                  },
                  [_vm._v("批量上架")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "u-btn",
                    on: {
                      click: function ($event) {
                        return _vm.pUp("0")
                      },
                    },
                  },
                  [_vm._v("批量下架")]
                ),
                _c(
                  "div",
                  { staticClass: "u-btn1", on: { click: _vm.toLink } },
                  [_vm._v("弹窗跳转设置")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", icon: "el-icon-plus" },
                    on: { click: _vm.add },
                  },
                  [_vm._v("添加商品")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", icon: "el-icon-upload2" },
                    on: {
                      click: function ($event) {
                        return _vm.exportData()
                      },
                    },
                  },
                  [_vm._v("批量导出")]
                ),
              ],
              1
            ),
          ]),
        ]),
        _c(
          "div",
          { attrs: { id: "base-list" } },
          [
            _c("lb-table", {
              directives: [
                {
                  name: "horizontal-scroll",
                  rawName: "v-horizontal-scroll",
                  value: "always",
                  expression: "'always'",
                },
              ],
              attrs: {
                column: _vm.columns,
                data: _vm.list,
                pagination: "",
                total: _vm.page.totalNum,
                layout: "total, sizes, prev, pager, next, jumper",
                "page-sizes": [5, 10, 20, 30, 50],
                "current-page": _vm.searchForm.pageNo,
                "page-size": _vm.searchForm.pageSize,
              },
              on: {
                "update:currentPage": function ($event) {
                  return _vm.$set(_vm.searchForm, "pageNo", $event)
                },
                "update:current-page": function ($event) {
                  return _vm.$set(_vm.searchForm, "pageNo", $event)
                },
                "selection-change": _vm.onMultipleSelection,
                "size-change": _vm.handleSizeChange,
                "p-current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "删除提示",
            visible: _vm.isD,
            width: "518px",
            "append-to-body": true,
            "custom-class": "infoI",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isD = $event
            },
          },
        },
        [
          [
            _c(
              "div",
              { staticClass: "info", staticStyle: { "text-align": "left" } },
              [
                _c("i", {
                  staticClass: "el-icon-warning",
                  staticStyle: { color: "red", "font-size": "20px" },
                }),
                _vm._v("删除后不可恢复数据，是否继续？ "),
              ]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "end",
                  "margin-top": "24px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info-q",
                    on: {
                      click: function ($event) {
                        _vm.isD = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "div",
                  { staticClass: "info-s", on: { click: _vm.deleteShop } },
                  [_vm._v("确定")]
                ),
              ]
            ),
          ],
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "温馨提示",
            visible: _vm.isLimit,
            width: "518px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isLimit = $event
            },
          },
        },
        [
          [
            _c("div", { staticClass: "info" }, [
              _c("i", {
                staticClass: "el-icon-warning",
                staticStyle: { color: "orange", "font-size": "20px" },
              }),
              _vm._v(
                "您已新增上架商品 " +
                  _vm._s(_vm.numberY) +
                  " 个，已达新增上架商品上限，若想继续新增商品，请下架其中一个商品； "
              ),
            ]),
            _c("div", { staticClass: "info-b" }, [
              _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
              _vm._v(" 若增加上架个数，请联系客服！ "),
            ]),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "end",
                  "margin-top": "24px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info-q",
                    on: {
                      click: function ($event) {
                        _vm.isLimit = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "info-s",
                    on: {
                      click: function ($event) {
                        return _vm.sLimit()
                      },
                    },
                  },
                  [_vm._v("确定")]
                ),
              ]
            ),
          ],
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "温馨提示",
            visible: _vm.isSup,
            width: "518px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isSup = $event
            },
          },
        },
        [
          [
            _c(
              "div",
              { staticClass: "info", staticStyle: { "text-align": "left" } },
              [
                _c("i", {
                  staticClass: "el-icon-warning",
                  staticStyle: { color: "orange", "font-size": "20px" },
                }),
                _vm._v("当前商品已上架第三方平台，是否确认下架？ "),
              ]
            ),
            _c("div", { staticClass: "info-b" }, [
              _vm._v("下架后所有平台都下架该商品！"),
            ]),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "end",
                  "margin-top": "24px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info-q",
                    on: {
                      click: function ($event) {
                        _vm.isSup = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "div",
                  { staticClass: "info-s", on: { click: _vm.sUpData } },
                  [_vm._v("确定")]
                ),
              ]
            ),
          ],
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "温馨提示",
            visible: _vm.isS,
            width: "518px",
            "append-to-body": true,
            "custom-class": "infoI",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isS = $event
            },
          },
        },
        [
          [
            _c(
              "div",
              { staticClass: "info", staticStyle: { "text-align": "left" } },
              [
                _c("i", {
                  staticClass: "el-icon-warning",
                  staticStyle: { color: "red", "font-size": "20px" },
                }),
                _vm._v(_vm._s(_vm.tName) + " "),
              ]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "end",
                  "margin-top": "24px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info-q",
                    on: {
                      click: function ($event) {
                        _vm.isS = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "div",
                  { staticClass: "info-s", on: { click: _vm.batchUp } },
                  [_vm._v("确定")]
                ),
              ]
            ),
          ],
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.titleU,
            visible: _vm.isU,
            width: "518px",
            "append-to-body": true,
            "custom-class": "infoI",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isU = $event
            },
          },
        },
        [
          [
            _c("div", [
              _c("i", {
                staticClass: "el-icon-warning",
                staticStyle: { color: "orange", "font-size": "20px" },
              }),
              _vm._v(_vm._s(_vm.contentU) + " "),
            ]),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "end",
                  "margin-top": "24px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info-q",
                    on: {
                      click: function ($event) {
                        _vm.isU = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "div",
                  { staticClass: "info-s", on: { click: _vm.updateUp } },
                  [_vm._v("确定")]
                ),
              ]
            ),
          ],
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "查看绑定SKU",
            visible: _vm.isSku,
            width: "40%",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isSku = $event
            },
          },
        },
        [
          [
            _c("div", [
              _c(
                "div",
                [
                  _c("lb-table", {
                    directives: [
                      {
                        name: "horizontal-scroll",
                        rawName: "v-horizontal-scroll",
                        value: "always",
                        expression: "'always'",
                      },
                    ],
                    attrs: { column: _vm.columnsT, data: _vm.skus },
                  }),
                ],
                1
              ),
            ]),
            _c("div", {
              staticStyle: {
                display: "flex",
                "justify-content": "center",
                "margin-top": "24px",
              },
            }),
          ],
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "广告链接设置",
            visible: _vm.isLink,
            width: "1050px",
            "append-to-body": true,
            "custom-class": "link",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isLink = $event
            },
          },
        },
        [
          [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "space-between",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "c-link",
                    on: {
                      click: function ($event) {
                        return _vm.createLink("add")
                      },
                    },
                  },
                  [_vm._v("创建链接")]
                ),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      "popper-class": "atooltip-c",
                      effect: "dark",
                      placement: "bottom-end",
                      "visible-arrow": false,
                      "hide-after": 0,
                    },
                  },
                  [
                    _c("div", { staticClass: "t-flow" }, [
                      _vm._v("选择投流小程序"),
                    ]),
                    _c(
                      "div",
                      { attrs: { slot: "content" }, slot: "content" },
                      [
                        _c("div", { staticClass: "f-title" }, [
                          _vm._v("已绑定小程序"),
                        ]),
                        _vm._l(_vm.flows, function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "f-item" },
                            [
                              _c("div", { staticClass: "name" }, [
                                _vm._v(_vm._s(item.name)),
                              ]),
                              _c("div", { staticClass: "ido" }, [
                                _vm._v("原始ID:" + _vm._s(item.originId)),
                                _c("img", {
                                  staticStyle: {
                                    width: "14px",
                                    height: "14px",
                                    "margin-left": "8px",
                                    "margin-top": "4px",
                                  },
                                  attrs: {
                                    src: require("../../../assets/icon_fuzhi@2x.png"),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.copyI(item.originId)
                                    },
                                  },
                                }),
                              ]),
                              _c("div", { staticClass: "id" }, [
                                _vm._v("AppID:" + _vm._s(item.appid)),
                                _c("img", {
                                  staticStyle: {
                                    width: "14px",
                                    height: "14px",
                                    "margin-left": "8px",
                                    "margin-top": "4px",
                                  },
                                  attrs: {
                                    src: require("../../../assets/icon_fuzhi@2x.png"),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.copyI(item.appid)
                                    },
                                  },
                                }),
                              ]),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "space-between",
                  "margin-top": "18px",
                },
              },
              [
                _c(
                  "div",
                  [
                    _c("el-input", {
                      staticStyle: { width: "232px" },
                      attrs: { placeholder: "请输入链接名称" },
                      on: { change: _vm.selectL },
                      model: {
                        value: _vm.lForm.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.lForm, "name", $$v)
                        },
                        expression: "lForm.name",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c("el-input", {
                      staticStyle: { width: "232px" },
                      attrs: { placeholder: "搜索广告账户" },
                      on: { change: _vm.selectL },
                      model: {
                        value: _vm.lForm.account,
                        callback: function ($$v) {
                          _vm.$set(_vm.lForm, "account", $$v)
                        },
                        expression: "lForm.account",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "232px" },
                        attrs: {
                          placeholder: "选择广告渠道",
                          filterable: "",
                          clearable: "",
                        },
                        on: { change: _vm.selectL },
                        model: {
                          value: _vm.lForm.ad,
                          callback: function ($$v) {
                            _vm.$set(_vm.lForm, "ad", $$v)
                          },
                          expression: "lForm.ad",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "腾讯广告", value: "1" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "232px" },
                        attrs: {
                          placeholder: "选择支付方式",
                          filterable: "",
                          clearable: "",
                        },
                        on: { change: _vm.selectL },
                        model: {
                          value: _vm.lForm.payType,
                          callback: function ($$v) {
                            _vm.$set(_vm.lForm, "payType", $$v)
                          },
                          expression: "lForm.payType",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "全部支付方式", value: "0" },
                        }),
                        _c("el-option", {
                          attrs: { label: "微信支付", value: "1" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "el-table",
              {
                staticStyle: { "margin-top": "18px" },
                attrs: {
                  data: _vm.links,
                  "header-cell-style": {
                    background: "#fafafa",
                    color: "#333333",
                  },
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    label: "广告投放链接",
                    headerAlign: "left",
                    width: "460px",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          _c("div", { staticStyle: { "text-align": "left" } }, [
                            _c("div", [
                              _c("span", [
                                _vm._v(
                                  _vm._s(props.row.name ? props.row.name : "--")
                                ),
                              ]),
                            ]),
                            _c("p", { staticClass: "accountId" }, [
                              _vm._v(
                                "广告账户ID:" +
                                  _vm._s(props.row.adAccountId || "--")
                              ),
                            ]),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "flex-wrap": "wrap",
                                },
                              },
                              [
                                _c("div", { staticClass: "accountId" }, [
                                  _vm._v(
                                    " 广告链接ID:" +
                                      _vm._s(
                                        props.row.id ? props.row.id : "--"
                                      ) +
                                      " "
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "flex-wrap": "wrap",
                                },
                              },
                              [
                                _c("div", { staticClass: "accountId" }, [
                                  _c("div", [_vm._v(_vm._s(props.row.url))]),
                                  _c("img", {
                                    staticStyle: {
                                      width: "14px",
                                      height: "14px",
                                      "margin-left": "8px",
                                      "margin-top": "4px",
                                      cursor: "pointer",
                                    },
                                    attrs: {
                                      src: require("../../../assets/icon_fuzhi@2x.png"),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyI(props.row.url)
                                      },
                                    },
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#2D46EE",
                                        "margin-left": "4px",
                                        cursor: "pointer",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.copyI(props.row.url)
                                        },
                                      },
                                    },
                                    [_vm._v("复制")]
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "margin-top": "11px",
                                },
                              },
                              [
                                _c("div", { staticClass: "ld" }, [
                                  _vm._v("图文落地页"),
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticClass: "ad",
                                    staticStyle: {
                                      "margin-left": "8px",
                                      "margin-right": "8px",
                                    },
                                  },
                                  [_vm._v("腾讯广告")]
                                ),
                                _c("div", { staticClass: "ad" }, [
                                  _vm._v("微信支付"),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "创建时间" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          _c("div", [
                            _vm._v(
                              " " + _vm._s(props.row.createdTime || "--") + " "
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c(
                  "el-table-column",
                  {
                    attrs: { label: "券后订单回传" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (props) {
                          return [
                            _c(
                              "div",
                              [
                                _c("el-switch", {
                                  attrs: {
                                    "active-text": "是",
                                    "inactive-text": "否",
                                    "active-color": "#2D46EE",
                                    disabled: "",
                                    "inactive-color": "#EBEEFA",
                                  },
                                  model: {
                                    value: props.row.statusL,
                                    callback: function ($$v) {
                                      _vm.$set(props.row, "statusL", $$v)
                                    },
                                    expression: "props.row.statusL",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticStyle: { "margin-top": "6px" } },
                              [_vm._v("回传100%")]
                            ),
                          ]
                        },
                      },
                    ]),
                  },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("div", [_vm._v("券后订单回传")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content:
                                  "开启后,回流订单将回传至广告侧，支持设置回传比例（实时回传中可能存在较小的误差）",
                                placement: "top",
                              },
                            },
                            [
                              _c("img", {
                                staticStyle: {
                                  width: "18px",
                                  height: "18px",
                                  "margin-left": "4px",
                                  "margin-top": "2px",
                                },
                                attrs: {
                                  src: require("../../../assets/icon/icon_qipao.png"),
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
                _c("el-table-column", {
                  attrs: { label: "操作", width: "100px" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          _c(
                            "div",
                            [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    placement: "right-start",
                                    width: "186",
                                    trigger: "click",
                                    "popper-class": "atooltip-y",
                                  },
                                },
                                [
                                  _c("div", [
                                    _c("div", { staticClass: "a-title" }, [
                                      _vm._v("落地页预览"),
                                    ]),
                                    _c("img", {
                                      staticStyle: {
                                        width: "128px",
                                        height: "128px",
                                        "margin-left": "29px",
                                      },
                                      attrs: { src: _vm.img },
                                    }),
                                    _c("div", { staticClass: "a-info" }, [
                                      _vm._v("手机微信扫码预览"),
                                    ]),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        color: "#2D46EE",
                                        width: "30px",
                                        cursor: "pointer",
                                      },
                                      attrs: { slot: "reference" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.preView(
                                            props.row,
                                            props.$index
                                          )
                                        },
                                      },
                                      slot: "reference",
                                    },
                                    [_vm._v("预览 ")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                color: "#2D46EE",
                                cursor: "pointer",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.createLink("edit", props.row)
                                },
                              },
                            },
                            [_vm._v("修改")]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                color: "#2D46EE",
                                cursor: "pointer",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.deteleL(props.row.id)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "b-pagination" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.lForm.pageNo,
                    "page-sizes": [5, 10, 20, 50],
                    "page-size": _vm.lForm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.lForm.total,
                  },
                  on: {
                    "size-change": _vm.handleSizeChangeL,
                    "current-change": _vm.handleCurrentChangeL,
                  },
                }),
              ],
              1
            ),
          ],
        ],
        2
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.drawerTitle,
            visible: _vm.drawer,
            size: 643,
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c("div", { staticClass: "d-content" }, [
            _c("div", { staticClass: "d-content-info" }, [
              _vm._v(
                "链接支持创建一个营销页，用户从广告页面划走后默认进入该营销页，进行二次回流转化。支持自定义上传素材，如未自定义则默认"
              ),
            ]),
            _c(
              "div",
              {
                staticStyle: {
                  "margin-top": "18px",
                  "margin-left": "32px",
                  "margin-right": "10px",
                },
              },
              [
                _c(
                  "el-form",
                  {
                    ref: "ruleForm",
                    staticClass: "ruleForm",
                    attrs: {
                      model: _vm.ruleForm,
                      rules: _vm.rules,
                      "label-width": "110px",
                      size: "small",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "链接名称", prop: "name" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "348px" },
                          attrs: { placeholder: "仅作为内部标记使用" },
                          model: {
                            value: _vm.ruleForm.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "name", $$v)
                            },
                            expression: "ruleForm.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "关联广告账户", prop: "adAccountId" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "232px" },
                            attrs: {
                              placeholder: "请选择广告渠道",
                              filterable: "",
                              clearable: "",
                            },
                            model: {
                              value: _vm.ruleForm.adAccountId,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "adAccountId", $$v)
                              },
                              expression: "ruleForm.adAccountId",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "腾讯广告", value: "1" },
                            }),
                          ],
                          1
                        ),
                        _c("el-input", {
                          staticStyle: {
                            width: "232px",
                            "margin-left": "12px",
                          },
                          attrs: { placeholder: "输入广告账户ID(可选填)" },
                          model: {
                            value: _vm.ruleForm.account,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "account", $$v)
                            },
                            expression: "ruleForm.account",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "落地页类型", prop: "ld" } },
                      [
                        _c(
                          "el-radio",
                          {
                            attrs: { label: "1" },
                            model: {
                              value: _vm.ruleForm.ld,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "ld", $$v)
                              },
                              expression: "ruleForm.ld",
                            },
                          },
                          [_vm._v("图文落地页")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "支付方式", prop: "payType1" } },
                      [
                        _c("div", { staticStyle: { display: "flex" } }, [
                          _c(
                            "div",
                            [
                              _c(
                                "el-checkbox",
                                {
                                  model: {
                                    value: _vm.ruleForm.payType1,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "payType1", $$v)
                                    },
                                    expression: "ruleForm.payType1",
                                  },
                                },
                                [_vm._v("微信支付")]
                              ),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "m-info" }, [
                            _vm._v("默认"),
                          ]),
                        ]),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { "font-size": "18px" },
                        attrs: { label: "营销页设置", prop: "marketing" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                            },
                          },
                          [
                            _c("el-switch", {
                              attrs: { "active-color": "#2D46EE" },
                              model: {
                                value: _vm.ruleForm.marketing,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "marketing", $$v)
                                },
                                expression: "ruleForm.marketing",
                              },
                            }),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "12px",
                                  "margin-left": "10px",
                                },
                              },
                              [
                                _vm._v(
                                  "打开可设置营销页，及优惠金额设置，建议开启"
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm.ruleForm.marketing
                      ? [
                          _c(
                            "el-form-item",
                            { attrs: { label: "页面类型", prop: "ld" } },
                            [
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: "1" },
                                  model: {
                                    value: _vm.ruleForm.ld,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "ld", $$v)
                                    },
                                    expression: "ruleForm.ld",
                                  },
                                },
                                [_vm._v("单品页")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "挽回优惠", prop: "couponId" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "232px" },
                                  attrs: {
                                    placeholder: "请选择优惠券",
                                    filterable: "",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.ruleForm.couponId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "couponId", $$v)
                                    },
                                    expression: "ruleForm.couponId",
                                  },
                                },
                                _vm._l(_vm.couponList, function (item, index) {
                                  return _c(
                                    "el-option",
                                    {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.id,
                                      },
                                    },
                                    [_vm._v(_vm._s(item.name))]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "营销页弹窗", prop: "popImg" } },
                            [
                              _c("upload-picture", {
                                attrs: {
                                  imageUrl: _vm.ruleForm.popImg,
                                  width: "108px",
                                  height: "108px",
                                },
                                on: {
                                  getUrl: function ($event) {
                                    return _vm.getImage($event, "popImg")
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "p-info" }, [
                            _vm._v("营销页弹窗在用户从广告商品详情划走后显示;"),
                            _c("br"),
                            _vm._v(
                              " 尺寸建议上传320*232px，每张上传大小不得超过2M,支持jpg、jpeg、png、gif格式;"
                            ),
                          ]),
                          _c(
                            "el-form-item",
                            { attrs: { label: "页面banner", prop: "banner" } },
                            [
                              _c("upload-picture", {
                                attrs: {
                                  imageUrl: _vm.ruleForm.banner,
                                  width: "108px",
                                  height: "108px",
                                },
                                on: {
                                  getUrl: function ($event) {
                                    return _vm.getImage($event, "banner")
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "p-info" }, [
                            _vm._v(
                              "营销页顶部banner；（不上传则使用默认banner提示"
                            ),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#2D46EE",
                                  cursor: "pointer",
                                },
                                on: { click: _vm.lookY },
                              },
                              [_vm._v("查看样式")]
                            ),
                            _vm._v("）"),
                            _c("br"),
                            _vm._v(
                              "尺寸建议宽度750px，每张上传大小不得超过2M,支持jpg、jpeg、png、gif格式;"
                            ),
                          ]),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "上传商品图", prop: "goodsImg" },
                            },
                            [
                              _c("upload-picture", {
                                attrs: {
                                  imageUrl: _vm.ruleForm.goodsImg,
                                  width: "108px",
                                  height: "108px",
                                },
                                on: {
                                  getUrl: function ($event) {
                                    return _vm.getImage($event, "goodsImg")
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "p-info" }, [
                            _vm._v("营请上传广告品对应的商品图；"),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#2D46EE",
                                  cursor: "pointer",
                                },
                                on: { click: _vm.lookY },
                              },
                              [_vm._v("查看样式")]
                            ),
                            _c("br"),
                            _vm._v(
                              " 尺寸建议跨度750px，每张上传大小不得超过2M,支持jpg、jpeg、png、gif格式;"
                            ),
                          ]),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "底部banner",
                                prop: "underBanner",
                              },
                            },
                            [
                              _c("upload-picture", {
                                attrs: {
                                  imageUrl: _vm.ruleForm.underBanner,
                                  width: "108px",
                                  height: "108px",
                                },
                                on: {
                                  getUrl: function ($event) {
                                    return _vm.getImage($event, "underBanner")
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "p-info" }, [
                            _vm._v(
                              "营销页底部banner；（不上传则使用默认banner提示"
                            ),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#2D46EE",
                                  cursor: "pointer",
                                },
                                on: { click: _vm.lookY },
                              },
                              [_vm._v("查看样式")]
                            ),
                            _vm._v("）"),
                            _c("br"),
                            _vm._v(
                              "尺寸建议宽度750px，每张上传大小不得超过2M,支持jpg、jpeg、png、gif格式;"
                            ),
                          ]),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "d-bottom" }, [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "start",
                  "padding-top": "24px",
                  "padding-left": "24px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info-q",
                    on: {
                      click: function ($event) {
                        _vm.drawer = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "div",
                  { staticClass: "info-s", on: { click: _vm.submitDrawer } },
                  [_vm._v("确定")]
                ),
              ]
            ),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "查看样式",
            visible: _vm.isLook,
            width: "635px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isLook = $event
            },
          },
        },
        [
          [
            _c("div", { staticStyle: { display: "flex" } }, [
              _c("div", { staticClass: "phone-v" }, [
                _vm.banner1
                  ? _c("div", [
                      _c("img", {
                        staticStyle: {
                          width: "375px",
                          height: "186px",
                          "margin-top": "119px",
                          "margin-left": "1px",
                        },
                        attrs: { src: _vm.banner1 },
                      }),
                    ])
                  : _vm._e(),
                _vm.ruleForm.goodsImg
                  ? _c("div", [
                      _c("img", {
                        staticStyle: {
                          width: "375px",
                          height: "233px",
                          "margin-left": "1px",
                          "margin-top": "-5px",
                        },
                        attrs: { src: _vm.ruleForm.goodsImg },
                      }),
                    ])
                  : _c("div", {
                      staticStyle: {
                        width: "375px",
                        height: "233px",
                        "margin-left": "1px",
                      },
                    }),
                _vm.underBanner1
                  ? _c("div", [
                      _c("img", {
                        staticStyle: {
                          width: "375px",
                          height: "130px",
                          "margin-left": "1px",
                          "margin-top": "-5px",
                          "border-bottom-left-radius": "16px",
                          "border-bottom-right-radius": "16px",
                        },
                        attrs: { src: _vm.underBanner1 },
                      }),
                    ])
                  : _vm._e(),
              ]),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    "justify-content": "space-between",
                  },
                },
                [
                  _c("div", { staticStyle: { height: "119px" } }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        height: "186px",
                        "flex-direction": "column",
                        "justify-content": "center",
                      },
                    },
                    [
                      _c("div", { staticStyle: { display: "flex" } }, [
                        _c("div", { staticClass: "line" }),
                        _c("div", { staticClass: "line-r" }),
                        _c("div", { staticClass: "r-title" }, [
                          _vm._v("页面banner"),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        height: "233px",
                        "flex-direction": "column",
                        "justify-content": "center",
                      },
                    },
                    [
                      _c("div", { staticStyle: { display: "flex" } }, [
                        _c("div", { staticClass: "line" }),
                        _c("div", { staticClass: "line-r" }),
                        _c("div", { staticClass: "r-title" }, [
                          _vm._v("商品图"),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        height: "130px",
                        "flex-direction": "column",
                        "justify-content": "center",
                      },
                    },
                    [
                      _c("div", { staticStyle: { display: "flex" } }, [
                        _c("div", { staticClass: "line" }),
                        _c("div", { staticClass: "line-r" }),
                        _c("div", { staticClass: "r-title" }, [
                          _vm._v("底部banner"),
                        ]),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
          ],
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "跳转第三方小程序",
            visible: _vm.isT,
            width: "487px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isT = $event
            },
          },
        },
        [
          [
            _c(
              "el-form",
              {
                ref: "returnForm",
                staticClass: "ruleForm",
                attrs: {
                  model: _vm.returnForm,
                  rules: _vm.rules,
                  "label-width": "110px",
                  size: "small",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "返回弹窗", prop: "returnImg" } },
                  [
                    _c("upload-picture", {
                      attrs: {
                        imageUrl: _vm.returnForm.returnImg,
                        width: "108px",
                        height: "108px",
                      },
                      on: {
                        getUrl: function ($event) {
                          return _vm.getImage1($event, "returnImg")
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "p-info" }, [
                  _vm._v("建议JPG、JPEG、PNG格式，大小500*600px，5M以内"),
                ]),
                _c(
                  "el-form-item",
                  { attrs: { label: "返回跳转链接", prop: "returnUrl" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "331px" },
                      attrs: { placeholder: "请输入链接" },
                      model: {
                        value: _vm.returnForm.returnUrl,
                        callback: function ($$v) {
                          _vm.$set(_vm.returnForm, "returnUrl", $$v)
                        },
                        expression: "returnForm.returnUrl",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "支付弹窗", prop: "paySuccessImg" } },
                  [
                    _c("upload-picture", {
                      attrs: {
                        imageUrl: _vm.returnForm.paySuccessImg,
                        width: "108px",
                        height: "108px",
                      },
                      on: {
                        getUrl: function ($event) {
                          return _vm.getImage1($event, "paySuccessImg")
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "p-info" }, [
                  _vm._v("建议JPG、JPEG、PNG格式，大小500*600px，5M以内"),
                ]),
                _c(
                  "el-form-item",
                  { attrs: { label: "支付跳转链接", prop: "paySuccessUrl" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "331px" },
                      attrs: { placeholder: "请输入链接" },
                      model: {
                        value: _vm.returnForm.paySuccessUrl,
                        callback: function ($$v) {
                          _vm.$set(_vm.returnForm, "paySuccessUrl", $$v)
                        },
                        expression: "returnForm.paySuccessUrl",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "end",
                  "margin-top": "24px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info-q",
                    on: {
                      click: function ($event) {
                        _vm.isT = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "div",
                  { staticClass: "info-s", on: { click: _vm.settingT } },
                  [_vm._v("确定")]
                ),
              ]
            ),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }